/**
 * NB: Lines are no longer dashed, as I couldn't find a good way of doing this with CSS only.
 * The SVG that used to drive this frequently caused "black background" issues in Safari,
 * @link https://linear.app/timelyapp/issue/TT-3229/safari-fix-timesheet-background-occasionally-rendering-with-black
 */
export function generateStripedBgPattern(options: { enabled: boolean; height: number }) {
  if (!options.enabled) {
    return {};
  }

  const color = 'var(--theme_color_content_divider_subtle)';

  return {
    backgroundImage: `linear-gradient(to bottom, ${color} 1px, transparent 1px)`,
    backgroundSize: `100% ${options.height}px`,
    backgroundRepeat: 'repeat',
  };
}
